export default "__VITE_ASSET__a5b724a1__"